

import { Component, Vue, Prop } from 'vue-property-decorator'
@Component
export default class AppSimpleLink extends Vue {
    @Prop() id!: number
    @Prop() routeLink!: string
}
